export default __webpack_public_path__ + "static/media/bg-desktop-dark.73e47dbb.jpg";